import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/component/header";
import AgentsGrid from "../_components/agents-grid";
import { agentRepo } from "@/repo/agent-repo";
import Footer from "@/component/footer";
import { AgentFullData } from "@/entry/server/agents";
import { Pagination } from "@/lib/api";
import { useQueryParams, getQueryParam } from "@/hooks/useQueryParams";

export default function Directors() {
    const queryParams = useQueryParams();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [agents, setAgents] = useState<AgentFullData[]>([]);
    const [pagination, setPagination] = useState<Pagination | null>(null);

    useEffect(function () {
        setLoading(true);
        var search = getQueryParam(queryParams, "search", "");
        var page = getQueryParam(queryParams, "page", "1");
        agentRepo.getAgents("directors", search, parseInt(page, 10)).then(function (response) {
            if (response.data) {
                setAgents(response.data);
            } else {
                setAgents([]);
            }
            if (response.pagination) {
                setPagination(response.pagination);
            }
            setLoading(false);
        });
    }, [location.search]);

    if (loading || !pagination) {
        return (
            <div className="page-loading">
                <div className="loader" />
            </div>
        );
    }

    return (
        <>
        <Header />
        <AgentsGrid type="directors" defaultAgents={agents} defaultPagination={pagination} />
        <Footer />
        </>
    );
}
